import React, { useRef, useState } from "react";
import { HiChevronDown } from "react-icons/hi2";

import "../css/Cover.css";

export default function Cover() {
    const scrollDown = () => {
        window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
    };

    return (
        <div className="intro-overlay">
            <button className="scroll-down-btn" onClick={scrollDown}>
                    <span className="arrow-down"><HiChevronDown /></span>
            </button>
        </div>
    );
}
